import {applySnapshot, types} from "mobx-state-tree"
import localstorable from "./mixins/localstoreable";
import loadable from "./mixins/loadable";

const defaultDashboardItems = [
    {"vizState":"{\"query\":{\"measures\":[\"Orders.count\"],\"timeDimensions\":[{\"dimension\":\"Orders.createdAt\",\"granularity\":\"month\"}],\"dimensions\":[\"Orders.status\"]},\"chartType\":\"bar\",\"sessionGranularity\":\"month\"}","name":"Orders by Status Over Time","id":"10","layout":"{\"x\":9,\"y\":8,\"w\":15,\"h\":8}"},{"vizState":"{\"query\":{\"measures\":[\"LineItems.cumulativeTotalRevenue\"],\"timeDimensions\":[{\"dimension\":\"LineItems.createdAt\",\"granularity\":\"month\",\"dateRange\":\"Last year\"}]},\"chartType\":\"area\",\"sessionGranularity\":\"month\"}","name":"Revenue Growth Last Year","id":"14","layout":"{\"x\":0,\"y\":0,\"w\":13,\"h\":8}"},{"vizState":"{\"query\":{\"measures\":[\"Orders.count\"],\"timeDimensions\":[{\"dimension\":\"Orders.completedAt\",\"granularity\":\"day\",\"dateRange\":\"Last 30 days\"}],\"filters\":[{\"dimension\":\"Orders.status\",\"operator\":\"equals\",\"values\":[\"completed\"]}]},\"chartType\":\"line\"}","name":"Completed Orders Last 30 days","id":"15","layout":"{\"x\":13,\"y\":0,\"w\":11,\"h\":8}"},{"vizState":"{\"query\":{\"measures\":[\"Orders.count\"],\"timeDimensions\":[{\"dimension\":\"Orders.completedAt\"}],\"dimensions\":[\"ProductCategories.name\"]},\"chartType\":\"bar\"}","name":"Orders by Product Category Name","id":"16","layout":"{\"x\":0,\"y\":16,\"w\":24,\"h\":8}"},{"vizState":"{\"query\":{\"dimensions\":[\"Orders.amountTier\"],\"timeDimensions\":[{\"dimension\":\"Orders.completedAt\"}],\"measures\":[\"Orders.count\"],\"filters\":[{\"dimension\":\"Orders.amountTier\",\"operator\":\"notEquals\",\"values\":[\"$0 - $100\"]}]},\"chartType\":\"pie\"}","name":"Orders by Price Tiers","id":"17",
        "layout":"{\"x\":0,\"y\":8,\"w\":9,\"h\":8}"}];

const layout = types.model(
    "layout",
    {
        x: types.number,
        y: types.number,
        w: types.number,
        h: types.number
    }
)

const wdElementModel = types
    .model("wdElement",
        {
            id: "",
            layout: "",
            vizState: "",
            name: "",
        }
    ).actions(
        self =>
            ({setLayout(value) {
                self.layout = value
            }
        })
    )

const dashboardModel  = types.model("wdDashboard",
    {
        name: "",
        id: "",
        title: "",
        description: "",
        path: "",
        dashboardItems: types.array(wdElementModel)
    }).actions(self => ({
    setItem(id, value) {
        value.layout = value.layout || "{\"x\":0,\"y\":0,\"w\":4,\"h\":8}"
        if (id)
        {
            const item = self.dashboardItems.filter(d => d.id == id)[0]
            if (item)
                applySnapshot(item, {id, ...value})
            else
                console.log("fail to find", id)
        }
        else
        {
            const newId = '' + (Math.max(1, ...self.dashboardItems.map(i => i.id)) + 1) || 1
            value.id = newId
            console.log("val", value)
            self.dashboardItems.push(value)
        }
    },
    setAll(value) {
        applySnapshot(self, value)
    },
    addValue(id, value) {
        self.dashboardItems.set(id, wdElementModel.create(value))
    },
    removeItem(id) {
        self.dashboardItems.replace(self.dashboardItems.filter(d => {
            return d.id != id}))
    },
})).extend(
    localstorable({
            default: defaultDashboardItems,
            path: "dashboardItems"
            })).extend(loadable(
    {url: '/api/wd/all',
        getUrl: (id) => `/api/wd/wd/${id}`,
        postUrl: (id) => `/api/wd/wd/${id}`}))

export default dashboardModel